import { ParamData } from './param-data';

/**
 * Klass för hantering av period-uppdatering
 */
export class PeriodData {
    constructor(
        public periodFrom: ParamData,
        public periodTo: ParamData,
        public showCurrentYear: boolean = false
    ) { }
}
